import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Primary } from '../../../assets/Colors';
import MembersIcon from '../../../assets/images/members.png';
import { getAllByRole } from '../../../api/BookSection';
import SideBar from '../../../components/SideBar';
import { Components } from '../../../assets/Dimensions';
import { setSelectedItem } from '../../../redux/actions/sidebarAction';

const StudentDashboard = ({ User, setSelectedItem }) => {
    const history = useHistory();
    const [stats, setStats] = useState({
        pendingTasks: 0
    });

    useEffect(() => {
        setSelectedItem('');
        const fetchStats = async () => {
             if (User && User.Id) {
                try {
                    // Fetch Pending Tasks (Work List Count)
                    let subRes = await getAllByRole({
                        UserId: User.Id,
                        PageSize: 1,
                        PageNumber: 0,
                        SearchValue: ""
                    }, User.Token);

                    setStats({
                        pendingTasks: subRes.status === 200 ? (subRes.data.RowCount || 0) : 0
                    });

                } catch (e) {
                     console.error("Failed to fetch stats", e);
                }
             }
        };

        fetchStats();
    }, [User]);

    const menuItems = [
        { title: 'Work List', path: '/worklist', icon: MembersIcon },
    ];

    return (
        <div>
            <SideBar />
            <div style={{ 
                padding: 20, 
                marginLeft: Components.SideBarWidth + 15, 
                marginRight: 30,
                paddingTop: 20
            }}>
            <Typography variant="h4" style={{ color: Primary.TextColor, marginBottom: 20 }}>
                Student Dashboard
            </Typography>

            {/* Statistics Section */}
            <Typography variant="h5" style={{ color: Primary.TextColor, marginBottom: 10 }}>
                Your Statistics
            </Typography>
            <Grid container spacing={3} style={{ marginBottom: 30 }}>
                 <Grid item xs={12} sm={6} md={3}>
                     <Card style={{ height: '100%', backgroundColor: Primary.Background }}>
                        <CardContent style={{ textAlign: 'center' }}>
                            <Typography variant="h3" style={{ color: Primary.TopBar }}>
                                {stats.pendingTasks}
                            </Typography>
                            <Typography variant="subtitle1" style={{ color: Primary.TextColor }}>
                                Pending Tasks
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* Menu Section */}
            <Typography variant="h5" style={{ color: Primary.TextColor, marginBottom: 10 }}>
                Quick Access
            </Typography>
            <Grid container spacing={3}>
                {menuItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card 
                            style={{ cursor: 'pointer', height: '100%' }}
                            onClick={() => history.push(item.path)}
                        >
                            <CardContent style={{ textAlign: 'center' }}>
                                <img src={item.icon} alt={item.title} style={{ width: 50, height: 50, marginBottom: 10 }} />
                                <Typography variant="h6" component="h2">
                                    {item.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    User: state.userReducer.User
});

const mapDispatchToProps = (dispatch) => ({
    setSelectedItem: (item) => dispatch(setSelectedItem(item))
});

export default connect(mapStateToProps, mapDispatchToProps)(StudentDashboard);
